'use client'; // Error components must be Client Components

import { useEffect, useState } from 'react';
import style from './error.module.css';
import Script from 'next/script';

interface ErrorProps {
    error: Error;
    reset?: () => void;
}

export default function Error({ error }: ErrorProps) {
    const [ddLoaded, setDdLoaded] = useState(false);

    useEffect(() => {
        const browserWindow = window as BrowserWindow;

        if (browserWindow.DD_RUM && browserWindow.location.hostname === 'www.siriusxm.com') {
            browserWindow.DD_RUM.init({
                clientToken: 'pub2efebd86de973d3161e20023ac07e68a',
                applicationId: 'c27edd08-fd30-4d05-ace8-21ad46980f08',
                site: 'datadoghq.com',
                service: 'sxm-cecm-web-www',
                env: 'proddelv',
                version: process.env.NEXT_PUBLIC_DD_VERSION || '1.0.0',
                sessionSampleRate: 45,
                sessionReplaySampleRate: 20,
                trackUserInteractions: true,
                trackResources: true,
                trackLongTasks: true,
                defaultPrivacyLevel: 'mask-user-input',
            });

            browserWindow.DD_RUM.addError(error, { 'page' : 'error.tsx' });
        }
        
    }, [ddLoaded, error]);
    
    return <body>
        <Script
            src="https://www.datadoghq-browser-agent.com/us1/v5/datadog-rum.js"
            onLoad={() => {
                setDdLoaded(true);
            }}
        />
        <iframe src={`/app-error`} className={style.iframe} />
    </body>;
}
